import { createAction, handleActions } from "redux-actions";
import { mapValues } from "lodash";

import TONES from "misc/tones";

const setParams = createAction("PAGES/SEARCH/SET_PARAMS");

const setCategories = createAction("PAGES/SEARCH/SET_CATEGORIES");
const setTones = createAction("PAGES/SEARCH/SET_TONES");
const setClearance = createAction("PAGES/SEARCH/SET_CLEARANCE");
const setFootageType = createAction("PAGES/SEARCH/SET_FOOTAGE_TYPE");
const setResolution = createAction("PAGES/SEARCH/SET_RESOLUTION");
const setOrientation = createAction("PAGES/SEARCH/SET_ORIENTATION");
const setUploaded = createAction("PAGES/SEARCH/SET_UPLOADED");
const setDates = createAction("PAGES/SEARCH/SET_DATES");
const setDuration = createAction("PAGES/SEARCH/SET_DURATION");
const setSort = createAction("PAGES/SEARCH/SET_SORT");
const setDisplay = createAction("PAGES/SEARCH/SET_DISPLAY");
const setPopularity = createAction("PAGES/SEARCH/SET_POPULARITY");
const setCustomTag = createAction("PAGES/SEARCH/SET_CUSTOM_TAG");
const setSmartSort = createAction("PAGES/SEARCH/SET_SMART_SORT");
const setSmartCountries = createAction("PAGES/SEARCH/SET_SMART_COUNTRIES");
const setCountries = createAction("PAGES/SEARCH/SET_COUNTRIES");
const setLocationsDialogOpen = createAction("PAGES/SEARCH/OPEN_LOCATIONS_DIALOG");
const resetParams = createAction("PAGES/SEARCH/RESET_PARAMS");
const setClearFromDrawer = createAction("PAGES/SEARCH/SET_CLEAR_FROM_DRAWER");
const setClearFromActiveFilters = createAction("PAGES/SEARCH/SET_CLEAR_FROM_ACTIVE_FILTERS");
const setClearedParams = createAction("PAGES/SEARCH/SET_CLEARED_PARAMS");

const tones = () =>
  TONES.map((item) => ({
    name: item,
    checked: false
  }));
const footageType = () => [
  {
    name: "Dashcam",
    checked: false
  },
  {
    name: "Drone",
    checked: false
  },
  { name: "Pov", checked: false },
  { name: "Security", checked: false }
];

const defaultState = {
  isLocationsDialogOpen: false,
  categories: [],
  tones: tones(),
  popularity: [
    { name: "Viral", checked: false },
    { name: "Popular", checked: false },
    { name: "Topical", checked: false }
  ],
  clearance: [
    {
      name: "Advertising Use",
      checked: false,
      value: "CLEARED"
    },
    {
      name: "Inquire for Advertising Use",
      checked: false,
      value: "LIMITATIONS"
    },
    {
      name: "No Advertising Use",
      checked: false,
      value: "NO_AR_EDITORIAL_ONLY"
    }
  ],
  footageType: footageType(),
  customTag: [],
  resolution: [
    { name: "All", checked: true },
    { name: "HD", checked: false }
  ],
  orientation: [
    { name: "Horizontal", checked: false },
    { name: "Vertical", checked: false }
  ],
  uploaded: [
    { name: "Any Date", checked: true },
    { name: "Last 72 hours", checked: false },
    { name: "Last 7 days", checked: false },
    { name: "Last 30 days", checked: false },
    { name: "Last 12 months", checked: false }
  ],
  dates: {
    acquiredFrom: null,
    acquiredTo: null,
    postedFrom: null,
    postedTo: null
  },
  sort: {
    signedDate: false,
    originalPublishingDate: false,
    duration: false
  },
  display: {
    asc: false,
    desc: false
  },
  duration: [0, 600],
  smartSort: [
    { name: "Most Relevant", checked: false },
    { name: "Most Recent", checked: false },
    { name: "Most Downloaded", checked: false },
    { name: "Duration: Long to Short", checked: false },
    { name: "Duration: Short to Long", checked: false }
  ],
  isClearFromDrawer: false,
  isClearFromActiveFilters: false,
  clearedParams: null,
  smartCountries: [],
  countries: []
};

const reducer = handleActions(
  {
    [setParams]: (state, action) => Object.assign({}, state, action.payload),
    [setCategories]: (state, action) => Object.assign({}, state, { categories: action.payload }),
    [setTones]: (state, action) => Object.assign({}, state, { tones: action.payload }),
    [setPopularity]: (state, action) => Object.assign({}, state, { popularity: action.payload }),
    [setClearance]: (state, action) => Object.assign({}, state, { clearance: action.payload }),
    [setFootageType]: (state, action) => Object.assign({}, state, { footageType: action.payload }),
    [setResolution]: (state, action) => Object.assign({}, state, { resolution: action.payload }),
    [setOrientation]: (state, action) => Object.assign({}, state, { orientation: action.payload }),
    [setUploaded]: (state, action) => Object.assign({}, state, { uploaded: action.payload }),
    [setDates]: (state, action) => {
      const dates = action.payload;
      const arePostedDatesValid = dates.postedFrom !== null && dates.postedTo !== null;

      return Object.assign({}, state, {
        dates: action.payload,
        uploaded: arePostedDatesValid ? defaultState.uploaded : state.uploaded
      });
    },
    [setDuration]: (state, action) => Object.assign({}, state, { duration: action.payload }),
    [setCustomTag]: (state, action) => Object.assign({}, state, { customTag: action.payload }),
    [setSmartSort]: (state, action) => Object.assign({}, state, { smartSort: action.payload }),
    [setLocationsDialogOpen]: (state, action) =>
      Object.assign({}, state, { isLocationsDialogOpen: action.payload }),
    [setSmartCountries]: (state, action) => {
      const smartCountries = action.payload;
      const countries = state.countries.map((country) => {
        const filterSmartCountries = smartCountries.filter((item) => item.name == country.name);

        if (filterSmartCountries.length > 0) {
          return { ...filterSmartCountries[0] };
        } else return { ...country };
      });

      return Object.assign({}, state, { smartCountries, countries });
    },
    [setCountries]: (state, action) => {
      const countries = action.payload;
      const smartCountries = state.smartCountries.map((smartCountry) => {
        const filteredCountries = countries.filter((item) => item.name == smartCountry.name);

        if (filteredCountries.length > 0) {
          return { ...filteredCountries[0] };
        } else return { ...smartCountry };
      });

      return Object.assign({}, state, { countries, smartCountries });
    },
    [setSort]: (state, action) => {
      const change = {
        ...mapValues(defaultState.sort, () => false),
        [action.payload]: true
      };
      return Object.assign({}, state, {
        sort: change
      });
    },
    [setDisplay]: (state, action) => {
      const change = {
        ...mapValues(defaultState.display, () => false),
        [action.payload]: true
      };
      return Object.assign({}, state, {
        display: change
      });
    },
    [resetParams]: (state) => {
      return {
        ...defaultState,
        tones: tones(),
        footageType: footageType(),
        isClearFromActiveFilters: state.isClearFromActiveFilters,
        isClearFromDrawer: state.isClearFromDrawer,
        clearedParams: state.clearedParams,
        countries: state.countries.map((country) => {
          return {
            ...country,
            checked: false
          };
        }),
        smartCountries: state.smartCountries.map((smartCountry) => {
          return {
            ...smartCountry,
            checked: false
          };
        })
      };
    },
    [setClearFromDrawer]: (state, action) =>
      Object.assign({}, state, { isClearFromDrawer: action.payload }),
    [setClearFromActiveFilters]: (state, action) =>
      Object.assign({}, state, { isClearFromActiveFilters: action.payload }),
    [setClearedParams]: (state, action) =>
      Object.assign({}, state, { clearedParams: action.payload })
  },
  defaultState
);

export {
  setParams,
  setCategories,
  setTones,
  setPopularity,
  setClearance,
  setFootageType,
  setResolution,
  setOrientation,
  setUploaded,
  setDates,
  setDuration,
  setCustomTag,
  setSort,
  setSmartSort,
  setDisplay,
  setSmartCountries,
  setCountries,
  setLocationsDialogOpen,
  resetParams,
  reducer,
  setClearFromActiveFilters,
  setClearFromDrawer,
  setClearedParams
};
